import React, { useState } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { TextField, Box, FormControl, FormHelperText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { DSLink, DSText } from '@engenharia/ds-react';
import Logo from '../../components/molecules/Logo';
import { Container, Card, FormContainer, LinkContainer } from './styles';
import Notification from '../../components/Notification';
import { mailValidation } from '../../utils/validations';
import api from '../../services/api';
import { getLanguage } from '../../services/auth';
import Button from '../../components/atoms/Button';
import MetaHeader from '../../components/MetaHeader';
import Header from '../../components/Header';
import { transcodeLanguage } from '../../utils/language';

export default function ForgotPassword() {
  const history = useHistory();
  const { t } = useTranslation();

  const [state, setState] = React.useState({
    email: '',
    mailValidation: {},
  });

  const [notification, setNotification] = useState({});

  const handleEmailChange = (event) => {
    setState({
      ...state,
      email: event.target.value,
      mailValidation: mailValidation(event.target.value),
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const language = transcodeLanguage(getLanguage());

      await api.post('/accounts/forgot_password', {
        email: state.email,
        language,
      });
      history.push('/accounts/forgot_password/mail_sent');
    } catch (error) {
      const { response } = error;
      setNotification({
        key: new Date().getTime(),
        message: response?.data?.message || t('errors.connection-failure'),
      });
    }
  };

  return (
    <>
      <Header positionFixed />
      <Container>
        <MetaHeader
          title="Esqueci minha Senha - mLabs | Gestão de redes sociais"
          description="mLabs - Gestão de Redes Sociais | Esqueceu a senha? Não se preocupe! Informe seu e-mail de acesso à mLabs e te enviaremos as instruções para redefinir sua senha."
        />
        <Logo />
        <Box mx={2} my={8} component={Card}>
          <DSText variant="h3" color="primary">
            {t('forgotPassword.title')}
          </DSText>
          <Box my={3}>
            <DSText variant="body2" color="textPrimary">
              {t('forgotPassword.subtitle')}
            </DSText>
          </Box>
          <FormContainer>
            <form onSubmit={handleSubmit}>
              <FormControl
                variant="outlined"
                error={state.emailRequiredError || state.emailInvalidError}
                fullWidth
              >
                <TextField
                  type="email"
                  error={state.emailRequiredError || state.emailInvalidError}
                  fullWidth
                  required
                  data-testid="formEmail"
                  id="email"
                  label={t('forgotPassword.input.email')}
                  value={state.email}
                  onChange={handleEmailChange}
                  variant="outlined"
                  autoComplete="email"
                  margin="normal"
                  autoFocus
                />
                {state.mailValidation.emailRequiredError && (
                  <FormHelperText error id="email-error">
                    {t('forgotPassword.input.invalidRequired')}
                  </FormHelperText>
                )}
                {state.mailValidation.emailInvalidError && (
                  <FormHelperText error id="email-error">
                    {t('forgotPassword.input.invalidFormat')}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth>
                <Button mt={4} type="submit" fullWidth color="primary" data-testid="formSubmit">
                  {t('forgotPassword.button.send')}
                </Button>
              </FormControl>
            </form>
          </FormContainer>
          <LinkContainer>
            <DSLink
              underline="always"
              variant="button"
              component={RouterLink}
              to="/"
              color="secondary"
            >
              {t('forgotPassword.signinLink')}
            </DSLink>
          </LinkContainer>
        </Box>
        {notification?.key && (
          <Notification
            index={notification.key}
            message={notification.message}
            button={notification.button}
          />
        )}
      </Container>
    </>
  );
}
